<div class="container-fluid" appPadding>
  <ng-container *ngIf="toolbox_talk.name">
    <h6>{{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }}</h6>
    <p>{{ toolbox_talk.name }}</p>
  </ng-container>

  <ng-container *ngIf="toolbox_talk.agenda">
    <h6>Agenda</h6>
    <div class="agenda-div" [innerHTML]="toolbox_talk.agenda | sanitizeHtml"></div>
  </ng-container>

  <ng-container *ngIf="toolbox_talk.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(toolbox_talk.created_by_user.hash, $event)"
         matTooltip="View User Public Profile">
        {{ toolbox_talk.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <h6>Created At</h6>
  <p>{{ (toolbox_talk.date_created * 1000) | timezoneConvertLong}}</p>

  <ng-container *ngIf="toolbox_talk.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(toolbox_talk.updated_by_user.hash, $event)"
         matTooltip="View User Public Profile">
        {{ toolbox_talk.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <h6>Last Updated At</h6>
  <p>{{ (toolbox_talk.date_modified * 1000) | timezoneConvertLong }}</p>

  <ng-container *ngIf="toolbox_talk.files?.length">
    <h6>Uploaded Files</h6>
    <app-files-list [view]="true" [files]="toolbox_talk.files"></app-files-list>
  </ng-container>

</div>
